import React, { useState } from "react";
import { Input, Button, Table, Card, message, Dropdown } from "antd";
import { SearchOutlined, CloseOutlined, DownOutlined } from "@ant-design/icons";
import Constants from "../Utils/Constants";
import useToken from "../Authentication/useToken";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
function EvaluationSearch() {
  const { t } = useTranslation("Evaluations");
  const { token } = useToken(); // R�cup�ration du token d'authentification
  const [searchTerm, setSearchTerm] = useState(""); // Stocke la valeur de la recherche
  const [patients, setPatients] = useState([]); // Liste des patients r�cup�r�s
  const [loading, setLoading] = useState(false); // Indicateur de chargement
  const [errorMessage, setErrorMessage] = useState(""); // Message d'erreur

  /**
   * Fonction pour naviguer vers la page d'affichage des �valuations
   */
  const navigateToEvaluations = (patientId) => {
    window.location.href = `/evaluations/patient/${patientId}`;
  };

  /**
   * Fonction pour effectue une recherche de patient par ID ou par nom
   */
  const handleSearch = async () => {
    if (!searchTerm.trim()) {
      // V�rifie si l'entr�e est vide
      message.warning(t("warn_missing_name_warning"));
      return;
    }

    setLoading(true);
    setPatients([]);
    setErrorMessage("");

    try {
      let endpoint;

      // V�rifie si l'entr�e est un ID ( uniqument des chiffres)
     if (/^\d+$/.test(searchTerm.trim())) {
  endpoint = `/evaluations/patient/${searchTerm.trim()}`;
} else {
  endpoint = `/evaluations/patients/search?term=${encodeURIComponent(searchTerm.trim())}`;
}

      console.log(`Envoi de la requ�te: ${Constants.SERVER_URL}${endpoint}`);

      const response = await fetch(`${Constants.SERVER_URL}${endpoint}`, {
        headers: { Authorization: "Bearer " + token },
      });

      if (!response.ok) {
        throw new Error(t("error_getting_patients"));
      }

      const data = await response.json();
      console.log("Donn�es re�ues:", data); // Debug : afficher la r�ponse de l'API

      if (!data || (Array.isArray(data) && data.length === 0)) {
        setErrorMessage(t("error_no_patients")); // Message si aucun r�sultat
      } else {
        // Si l'API retourne un seul objet patient, on le convertit en tableau
        setPatients(Array.isArray(data) ? data : [data]);
      }
    } catch (error) {
      console.error(" Erreur lors de la recherche:", error);
      setErrorMessage(t("error_search"));
    } finally {
      setLoading(false); // Arr�ter le chargement une fois la requ�te termin�e
    }
  };

  /**
   * Fonction pour r�initialiser la recherche
   */
  const clearSearch = () => {
    setSearchTerm("");
    setPatients([]);
    setErrorMessage("");
  };

  const evaluationItems = [
    {
      label: t("button_pace"),
      key: '0',
      route: 'evaluation-pace'
    },
    {
      label: t("button_path"),
      key: '1',
      route: 'evaluation-path'
    },
    {
      label: t("button_match"),
      key: '2',
      route: 'evaluation-match'
    }
  ];

  const appelSuiviItems = [
    {
      label: t("button_pace"),
      key: '0',
      route: 'follow-up-pace'
    },
    {
      label: t("button_path"),
      key: '1',
      route: 'follow-up-path'
    },
    {
      label: t("button_match"),
      key: '2',
      route: 'follow-up-match'
    },
  ];

  /**
   * D�finition des colonnes du tableau d'affichage des patients
   */
  const columns = [
    {
      title: t("title_table_column_lastname"),
      dataIndex: "lastname",
      key: "lastname",
    },
    {
      title: t("title_table_column_firstname"),
      dataIndex: "firstname",
      key: "firstname",
    },
    {
      title: t("title_table_column_birthday"),
      dataIndex: "birthday",
      key: "Birthday",
    },
    {
      title: t("title_actions"),
      key: "actions",
      render: (_, patient) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", gap: "16px" }}>
            <Dropdown
              menu={{
                items: evaluationItems,
                onClick: (e) => {
                  const i = evaluationItems.find(i => i.key === e.key);
                  (window.location.href = `/${i.route}/${patient.id}`);
                }
              }}
              trigger={['click']}>
              <Button type="primary">
                {t("button_evaluation")}
                <DownOutlined/>
              </Button>
            </Dropdown>

            <Dropdown 
              menu={{ 
                items: appelSuiviItems,
                onClick: (e) => {
                  const i = appelSuiviItems.find(i => i.key === e.key);
                  (window.location.href = `/${i.route}/${patient.id}`);
                }
              }} 
              trigger={['click']}>
              <Button type="primary">
                {t("button_followup")}
                <DownOutlined />
              </Button>
            </Dropdown>
          </div>

          <Button
            type="primary"
            onClick={() => navigateToEvaluations(patient.id)}
          >
            {t("button_show_evaluations")}
          </Button>
        </div>
      ),
      width: "60%", // Assurer que la colonne est suffisamment large
    },
  ];

  useEffect(() => {
  const fetchAllPatients = async () => {
    try {
      const res = await fetch(`${Constants.SERVER_URL}/patients`, {
        headers: { Authorization: "Bearer " + token },
      });
      if (!res.ok) throw new Error("Erreur serveur");
      const data = await res.json();
      setPatients(data); // Afficher tous les patients
    } catch (error) {
      console.error("Erreur lors du chargement initial des patients :", error);
      setErrorMessage("Impossible de charger les patients.");
    }
  };

  fetchAllPatients();
}, [token]);

  return (
    <div className="p-6">
      <Card title={t("search_title")} className="shadow-sm">
        <div className="mb-6" style={{ marginBottom: "16px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* Champs de recherche */}
            <div style={{ flex: 1, marginRight: "8px" }}>
              <Input
                placeholder={t("placeholder_search")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onPressEnter={handleSearch}
                prefix={<SearchOutlined />}
                suffix={
                  searchTerm && (
                    <Button
                      onClick={clearSearch}
                      size="small"
                      icon={<CloseOutlined />}
                    />
                  )
                }
              />
            </div>
            {/* Bouton de recherche */}
            <Button type="primary" onClick={handleSearch} loading={loading}>
              Rechercher
            </Button>
          </div>
        </div>

        {/* Affichage messages d'erreur */}
        {errorMessage ? (
          <div className="text-center py-8 text-red-500">
            {errorMessage}
          </div>
        ) : (
          // Tableau d'affichage des patients
          <Table
            columns={columns}
            dataSource={patients}
            rowKey="id"
            loading={loading}
            pagination={{ pageSize: 5 }}
            bordered
          />
        )}
      </Card>
    </div>
  );
}

export default EvaluationSearch;
